
import { Link } from "react-router-dom"
import textServices from "services/text-services"
import Arrow from "components/icon/menu-profile/arrow"
import { useSession } from "contexts/session-context"
import { useMemo } from "react"
import dayjs from "dayjs"
import { usePopupContext } from "hooks/use-main-cass"
import EditProfileV2 from "components/forms/v2/EditProfile"
import EditPhoneV2 from "components/forms/v2/EditPhone"
import EditAddressV2 from "components/forms/v2/EditAddress"
import EditAccounts from "components/forms/v2/EditAccounts"
import Instagram from "components/icon/instagram"
import { ContainerMenu, HeaderColorArrow, TitlePage } from "../styles/header.style"

export default function MenuProfileV2() {
  const [{ user }] = useSession()
  const { openPopup } = usePopupContext()

  const dateUser = useMemo(() => {
    if (user?.birthday) {
      return dayjs(user?.birthday).format('DD/MM/YYYY')
    }

    return 'Sin información'
  }, [user])

  const handleEditProfile = () => {
    openPopup(<EditProfileV2
      defaultValues={
        {
          imageUser: user?.imageUrl,
          firstName: user?.firstName,
          lastName: user?.lastName,
          birthday: user?.birthday,
          nickName: user?.nickName,
          genreId: user?.genreId
        }
      }
    />)
  }

  const handleEditPhone = () => {
    openPopup(<EditPhoneV2
      defaultValues={
        {
          phoneNumber: user?.phoneNumber,
        }
      }
    />)
  }

  const handleEditAddress = () => {
    openPopup(<EditAddressV2
      defaultValues={
        {
          apartament: user?.address?.apartament,
          city: user?.address?.city,
          neighborhood: user?.address?.neighborhood,
          postalCode: user?.address?.postalCode,
          state: user?.address?.state,
          street1: user?.address?.street1,
          streetNumber: user?.address?.streetNumber,
          streetType: `${user?.address?.streetType}`
        }
      }
    />)
  }

  const handleInstagram = () => {
    openPopup(<EditAccounts
      defaultValues={
        {
          instagram: user?.instagram,
        }
      }
    />)
  }

  return (
    <ContainerMenu className="menuprofile w-full bg-white text-black flex flex-col pt-14 flex-1">
      <div className='p-5 px-4 flex justify-between items-center menuprofile__container'>
        <Link to="/home" >
          <HeaderColorArrow>
            {textServices.findByText('profile/view/arrow', <Arrow />)}
          </HeaderColorArrow>
        </Link>
        <TitlePage className="text-center text-4xl font-bold">{textServices.findByText('profile/menu/title', { es: 'Mi información', en: 'My information' })}</TitlePage>
        <HeaderColorArrow className='opacity-0'>
          <Arrow />
        </HeaderColorArrow>
      </div>
      <div className="px-4 flex flex-col gap-5 flex-1 pb-8">
        <div className="user-info">
          <img src={user?.imageUrl ? user?.imageUrl : `${AZURE_BASE_URL}/menu_offline_user-icon.webp`} className="user-info__img" />
          <div>
            <h3 className="user-info__id">{user?.firstName} {user?.lastName}</h3>
            <p className="user-info__id-number">ID° {user?.id}</p>
          </div>
        </div>
        <div className="space-y-9 flex-1">
          <div className="space-y-2">
            <div className="flex items-center gap-2 text medium font-bold">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.5 0H3.5V0.5H8.5V0H9.5V0.5H11.5V11.5H0.5V0.5H2.5V0ZM1.5 1.5V2.5H10.5V1.5H9.5V2H8.5V1.5H3.5V2H2.5V1.5H1.5ZM1.5 3.5V10.5H10.5V3.5H1.5ZM4.5 4.5H5.5V5.5H4.5V4.5ZM6.5 4.5H7.5V5.5H6.5V4.5ZM8.5 4.5H9.5V5.5H8.5V4.5ZM6 6H8V8H6V6ZM2.5 6.5H3.5V7.5H2.5V6.5ZM4.5 6.5H5.5V7.5H4.5V6.5ZM8.5 6.5H9.5V7.5H8.5V6.5ZM2.5 8.5H3.5V9.5H2.5V8.5ZM4.5 8.5H5.5V9.5H4.5V8.5ZM6.5 8.5H7.5V9.5H6.5V8.5Z" fill="currentColor" />
              </svg>
              FECHA DE NACIMIENTO
            </div>
            <p className="description big">{dateUser}</p>
          </div>
          <div className="space-y-2">
            <div className="flex items-center gap-2 text medium font-bold">
              <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 0.5C5.63542 0.5 6.21875 0.65625 6.75 0.96875C7.29167 1.28125 7.71875 1.70833 8.03125 2.25C8.34375 2.78125 8.5 3.36458 8.5 4C8.5 4.59375 8.35938 5.14583 8.07812 5.65625C7.80729 6.16667 7.43229 6.58333 6.95312 6.90625C7.54688 7.16667 8.07292 7.52604 8.53125 7.98438C9 8.44271 9.35938 8.96875 9.60938 9.5625C9.86979 10.1771 10 10.8229 10 11.5H9C9 10.7708 8.81771 10.1042 8.45312 9.5C8.09896 8.88542 7.61458 8.40104 7 8.04688C6.39583 7.68229 5.72917 7.5 5 7.5C4.27083 7.5 3.59896 7.68229 2.98438 8.04688C2.38021 8.40104 1.89583 8.88542 1.53125 9.5C1.17708 10.1042 1 10.7708 1 11.5H0C0 10.8229 0.130208 10.1771 0.390625 9.5625C0.640625 8.96875 0.994792 8.44271 1.45312 7.98438C1.92188 7.52604 2.45312 7.16667 3.04688 6.90625C2.56771 6.58333 2.1875 6.16667 1.90625 5.65625C1.63542 5.14583 1.5 4.59375 1.5 4C1.5 3.36458 1.65625 2.78125 1.96875 2.25C2.28125 1.70833 2.70312 1.28125 3.23438 0.96875C3.77604 0.65625 4.36458 0.5 5 0.5ZM5 1.5C4.54167 1.5 4.11979 1.61458 3.73438 1.84375C3.35938 2.0625 3.05729 2.36458 2.82812 2.75C2.60938 3.125 2.5 3.54167 2.5 4C2.5 4.45833 2.60938 4.88021 2.82812 5.26562C3.05729 5.64062 3.35938 5.94271 3.73438 6.17188C4.11979 6.39062 4.54167 6.5 5 6.5C5.45833 6.5 5.875 6.39062 6.25 6.17188C6.63542 5.94271 6.9375 5.64062 7.15625 5.26562C7.38542 4.88021 7.5 4.45833 7.5 4C7.5 3.54167 7.38542 3.125 7.15625 2.75C6.9375 2.36458 6.63542 2.0625 6.25 1.84375C5.875 1.61458 5.45833 1.5 5 1.5Z" fill="currentColor" />
              </svg>
              GÉNERO
            </div>
            <p className="description big">{user?.genre ?? 'Sin información'}</p>
          </div>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 text medium font-bold">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.32812 0.5C3.59896 0.5 3.84375 0.588542 4.0625 0.765625L4.10938 0.796875L6.15625 2.90625L6.14062 2.92188C6.35938 3.13021 6.46875 3.38542 6.46875 3.6875C6.46875 3.98958 6.36458 4.24479 6.15625 4.45312L5.15625 5.45312C5.51042 6.26562 5.97396 6.94271 6.54688 7.48438C7.14062 8.04688 7.82292 8.51562 8.59375 8.89062L9.59375 7.89062C9.80208 7.68229 10.0625 7.57812 10.375 7.57812C10.6875 7.57812 10.9479 7.68229 11.1562 7.89062L11.1719 7.92188L13.2031 9.95312C13.4115 10.1615 13.5156 10.4219 13.5156 10.7344C13.5156 11.0365 13.4115 11.2917 13.2031 11.5L11.625 13.0781C11.3854 13.2865 11.1094 13.4219 10.7969 13.4844C10.4948 13.5469 10.1927 13.526 9.89062 13.4219H9.875C7.63542 12.5469 5.74479 11.3385 4.20312 9.79688C3.26562 8.85938 2.44792 7.80208 1.75 6.625C1.25 5.77083 0.859375 4.9375 0.578125 4.125V4.10938C0.473958 3.81771 0.458333 3.52083 0.53125 3.21875C0.604167 2.90625 0.760417 2.64062 1 2.42188L0.984375 2.40625L2.5625 0.78125L2.59375 0.765625C2.8125 0.588542 3.05729 0.5 3.32812 0.5ZM3.32812 1.5C3.29688 1.5 3.26042 1.51562 3.21875 1.54688L1.67188 3.125C1.58854 3.19792 1.53125 3.30208 1.5 3.4375C1.46875 3.5625 1.47396 3.67708 1.51562 3.78125C1.77604 4.52083 2.14062 5.29688 2.60938 6.10938C3.26562 7.22396 4.03125 8.21875 4.90625 9.09375C6.32292 10.5104 8.08854 11.6354 10.2031 12.4688C10.4948 12.5625 10.75 12.5156 10.9688 12.3281L12.5312 10.7656C12.5521 10.7448 12.5625 10.7344 12.5625 10.7344C12.5625 10.724 12.5521 10.7083 12.5312 10.6875L10.4375 8.59375C10.4062 8.5625 10.3854 8.54688 10.375 8.54688C10.3646 8.54688 10.3438 8.5625 10.3125 8.59375L8.8125 10.0938L8.10938 9.76562C7.77604 9.59896 7.45312 9.41146 7.14062 9.20312C6.70312 8.92188 6.3125 8.625 5.96875 8.3125L5.85938 8.21875C5.50521 7.875 5.17188 7.47396 4.85938 7.01562C4.64062 6.68229 4.44271 6.33333 4.26562 5.96875L4.07812 5.53125L3.96875 5.21875L4.20312 5L5.45312 3.75C5.48438 3.71875 5.49479 3.68229 5.48438 3.64062L3.4375 1.54688C3.39583 1.51562 3.35938 1.5 3.32812 1.5Z" fill="currentColor" />
                </svg>
                CONTACTO
              </div>
              <button className="flex gap-2 items-center cursor-pointer button-edit" onClick={handleEditPhone}>
                <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.5 1.50011H3C2.73478 1.50011 2.48043 1.60547 2.29289 1.79301C2.10536 1.98054 2 2.2349 2 2.50011V9.50011C2 9.76533 2.10536 10.0197 2.29289 10.2072C2.48043 10.3948 2.73478 10.5001 3 10.5001H10C10.2652 10.5001 10.5196 10.3948 10.7071 10.2072C10.8946 10.0197 11 9.76533 11 9.50011V6.00011M9.6875 1.31261C9.88641 1.1137 10.1562 1.00195 10.4375 1.00195C10.7188 1.00195 10.9886 1.1137 11.1875 1.31261C11.3864 1.51153 11.4982 1.78131 11.4982 2.06261C11.4982 2.34392 11.3864 2.6137 11.1875 2.81261L6.681 7.31961C6.56227 7.43824 6.4156 7.52507 6.2545 7.57211L4.818 7.99211C4.77498 8.00466 4.72937 8.00541 4.68595 7.99429C4.64254 7.98317 4.60291 7.96058 4.57122 7.92889C4.53953 7.8972 4.51694 7.85757 4.50582 7.81416C4.4947 7.77074 4.49545 7.72514 4.508 7.68211L4.928 6.24561C4.97526 6.08464 5.06227 5.93814 5.181 5.81961L9.6875 1.31261Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <p>EDITAR</p>
              </button>
            </div>
            <p className="description big">{user?.phoneNumber ?? 'Sin información'}</p>
          </div>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 text medium font-bold">
                <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 0.5C5.8125 0.5 6.56771 0.703125 7.26562 1.10938C7.94271 1.51562 8.48438 2.05729 8.89062 2.73438C9.29688 3.43229 9.5 4.1875 9.5 5C9.5 5.32292 9.4375 5.69792 9.3125 6.125C9.20833 6.47917 9.04688 6.90104 8.82812 7.39062C8.47396 8.19271 8.01042 9.08854 7.4375 10.0781C7.02083 10.8073 6.55729 11.5573 6.04688 12.3281L5 13.875L4.59375 13.2812C4.42708 13.0417 4.21354 12.724 3.95312 12.3281C3.44271 11.5573 2.97917 10.8073 2.5625 10.0781C1.98958 9.08854 1.52604 8.19271 1.17188 7.39062C0.953125 6.90104 0.791667 6.47917 0.6875 6.125C0.5625 5.69792 0.5 5.32292 0.5 5C0.5 4.1875 0.703125 3.43229 1.10938 2.73438C1.51562 2.05729 2.05729 1.51562 2.73438 1.10938C3.43229 0.703125 4.1875 0.5 5 0.5ZM5 1.5C4.36458 1.5 3.77604 1.65625 3.23438 1.96875C2.70312 2.28125 2.28125 2.70833 1.96875 3.25C1.65625 3.78125 1.5 4.36458 1.5 5C1.5 5.19792 1.55208 5.47917 1.65625 5.84375C1.76042 6.19792 1.90104 6.57812 2.07812 6.98438C2.38021 7.67188 2.83333 8.53646 3.4375 9.57812C3.94792 10.4531 4.45833 11.276 4.96875 12.0469L5 12.0781L5.03125 12.0469C5.54167 11.276 6.05208 10.4531 6.5625 9.57812C7.16667 8.53646 7.61979 7.67188 7.92188 6.98438C8.09896 6.57812 8.23958 6.19792 8.34375 5.84375C8.44792 5.47917 8.5 5.19792 8.5 5C8.5 4.36458 8.34375 3.78125 8.03125 3.25C7.71875 2.70833 7.29167 2.28125 6.75 1.96875C6.21875 1.65625 5.63542 1.5 5 1.5ZM5 4C5.28125 4 5.51562 4.09896 5.70312 4.29688C5.90104 4.48438 6 4.71875 6 5C6 5.28125 5.90104 5.52083 5.70312 5.71875C5.51562 5.90625 5.28125 6 5 6C4.71875 6 4.47917 5.90625 4.28125 5.71875C4.09375 5.52083 4 5.28125 4 5C4 4.71875 4.09375 4.48438 4.28125 4.29688C4.47917 4.09896 4.71875 4 5 4Z" fill="white" />
                </svg>
                DIRECCIÓN
              </div>
              <button className="flex gap-2 items-center cursor-pointer button-edit" onClick={handleEditAddress}>
                <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.5 1.50011H3C2.73478 1.50011 2.48043 1.60547 2.29289 1.79301C2.10536 1.98054 2 2.2349 2 2.50011V9.50011C2 9.76533 2.10536 10.0197 2.29289 10.2072C2.48043 10.3948 2.73478 10.5001 3 10.5001H10C10.2652 10.5001 10.5196 10.3948 10.7071 10.2072C10.8946 10.0197 11 9.76533 11 9.50011V6.00011M9.6875 1.31261C9.88641 1.1137 10.1562 1.00195 10.4375 1.00195C10.7188 1.00195 10.9886 1.1137 11.1875 1.31261C11.3864 1.51153 11.4982 1.78131 11.4982 2.06261C11.4982 2.34392 11.3864 2.6137 11.1875 2.81261L6.681 7.31961C6.56227 7.43824 6.4156 7.52507 6.2545 7.57211L4.818 7.99211C4.77498 8.00466 4.72937 8.00541 4.68595 7.99429C4.64254 7.98317 4.60291 7.96058 4.57122 7.92889C4.53953 7.8972 4.51694 7.85757 4.50582 7.81416C4.4947 7.77074 4.49545 7.72514 4.508 7.68211L4.928 6.24561C4.97526 6.08464 5.06227 5.93814 5.181 5.81961L9.6875 1.31261Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <p>EDITAR</p>
              </button>
            </div>
            {
              user?.address && user?.address?.streetNumber ? (
                <div>
                  <p className="description big">
                    {user?.address?.street1}, {user?.address?.streetNumber},
                    {user?.address?.shippingDetails && <span> {user?.address?.shippingDetails},</span>}
                  </p>
                  {user?.address?.street2 && (
                    <p className="description big">
                      {user?.address?.street2}
                    </p>
                  )}
                  <p className="description big">
                    {user?.address?.state},
                  </p>
                  <p className="description big">
                    {user?.address?.city},
                  </p>
                  <p className="description big">
                    {user?.address?.neighborhood},
                  </p>
                  <p className="description big">
                    CP {user?.address?.postalCode}
                  </p>
                </div>
              ) : (
                <p className="description big">Sin información</p>
              )
            }
          </div>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2 text medium font-bold">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_2400_6815)">
                    <path d="M6.24988 8.12644C6.51829 8.48527 6.86073 8.78218 7.25397 8.99703C7.64722 9.21188 8.08207 9.33964 8.52904 9.37165C8.976 9.40366 9.42462 9.33917 9.84447 9.18256C10.2643 9.02594 10.6456 8.78086 10.9624 8.46394L12.8374 6.58894C13.4066 5.99956 13.7216 5.21018 13.7145 4.39081C13.7074 3.57145 13.3787 2.78766 12.7993 2.20826C12.2199 1.62886 11.4361 1.30021 10.6168 1.29309C9.79739 1.28597 9.00801 1.60095 8.41863 2.17019L7.34363 3.23894M8.74988 6.87644C8.48147 6.51761 8.13903 6.2207 7.74579 6.00586C7.35254 5.79101 6.91769 5.66325 6.47072 5.63124C6.02376 5.59922 5.57514 5.66371 5.15529 5.82033C4.73544 5.97695 4.35418 6.22202 4.03738 6.53894L2.16238 8.41394C1.59314 9.00333 1.27815 9.79271 1.28527 10.6121C1.29239 11.4314 1.62105 12.2152 2.20045 12.7946C2.77985 13.374 3.56364 13.7027 4.383 13.7098C5.20237 13.7169 5.99175 13.4019 6.58113 12.8327L7.64988 11.7639" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2400_6815">
                      <rect width="15" height="15" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                VINCULA TUS CUENTAS
              </div>
            </div>
            {user?.instagram &&
              <p className="description big">
                {user?.instagram.includes('@') ? user?.instagram : `@${user?.instagram}`}
              </p>
            }
            <button onClick={handleInstagram} className="flex items-center justify-center w-full cursor-pointer gap-4 py-3 px-7 border border-solid border-white rounded-3xl">
              <Instagram className="w-4 h-4" />
              <p className="text big font-bold">{user?.instagram ? 'Editar mi cuenta de Instagram' : 'Agregar mi cuenta de Instagram'}</p>
            </button>
          </div>
        </div>
        <button className="button-edit big" onClick={handleEditProfile}><p>Editar mis datos</p></button>
      </div>
    </ContainerMenu>
  )
}